import botIcon3 from '../../assets/bot-icons/bot-icon-authdocs.svg';
import botIcon1 from '../../assets/bot-icons/bot-icon-default.svg';
import botIcon5 from '../../assets/bot-icons/bot-icon-sites.svg';
import botIcon2 from '../../assets/bot-icons/bot-icon-spo.svg';
import botIcon4 from '../../assets/bot-icons/bot-icon-web.svg';

export const getScopeIcon = (scope: string | undefined): string => {
    const scopeType = scope?.split(':')[0].toLowerCase();

    switch (scopeType) {
        case 'agent':
            return botIcon4;
        case 'recommendedsites':
            return botIcon5;
        case 'authdocs':
            return botIcon3;
        case 'spo':
            return botIcon2;
        default:
            return botIcon1;
    }
};
